import styled from 'styled-components';

export interface IListable {
  first: boolean;
  last: boolean;
}

export const Section = styled.section<IListable>`
  display: block;
  padding: 1rem 0 1rem;
  padding-top: ${({ first }) => (first ? '2rem' : '1rem')};
  padding-bottom: ${({ last }) => (last ? '2rem' : '1rem')};

  ${Styles.desktop`
    padding-top: ${({ first }: IListable) => (first ? '2rem' : '1rem')};
    padding-bottom: ${({ last }: IListable) => (last ? '2rem' : '1rem')};
  `}
`;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const Spacer = (_: { $hasBottomServiceMode: boolean }) => null;
